
const Xembify = () => {
  return (
    <>
      <div className="mx-auto">
        <div className="mt-10 font-bold">
          ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE
        </div>

        <ul className="list-disc ml-10">
          <li className="my-2">Commercially insured patients only</li>
          <li className="my-2">Assistance available for the treatment of PIDD (primary humoral immunodeficiency disease)</li>
          <li className="my-2">Patients' health plan permits members to participate in copay assistance programs
          </li>
        </ul>

        <div className="mt-10 font-bold">
          RESTRICTIONS
        </div>

        <ul className="list-disc ml-10">
          <li className="my-2">Patients are ineligible for copay assistance if they participate in Medicare, Medicaid, Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or state-funded programs
          </li>
        </ul>

      </div>
    </>
  );
};

export default Xembify;
